import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import styles from './BaseButton.module.scss';

const BaseButton: FC<IProps> = (props) => {
    return (
        <button
            type={'button'}
            className={
                classNames(styles.baseButton, props.className, {
                    [styles.isDisabled]: props.isDisabled,
                })
            }
            disabled={props.isDisabled}
            onClick={props.onClick}
        >
            {
                props.iconLeft &&
                <div className={styles.iconLeft}>
                    {props.iconLeft}
                </div>
            }
            {props.text}
        </button>
    );
};

export default BaseButton;
